module.exports = __webpack_public_path__ + "static/img/1-3.faf0264.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/1-3.png
// module id = foS+
// module chunks = 0